module.exports.BinarySearchTree = require('./lib/bst')
module.exports.AVLTree = require('./lib/avltree')
